<template>
    <el-container class="tx-page">
        <!-- 背景装饰层：霓虹光斑 + 网格 -->
        <div class="tx-bg">
            <div class="tx-orb tx-orb-cyan"></div>
            <div class="tx-orb tx-orb-purple"></div>
            <div class="tx-orb tx-orb-blue"></div>
            <div class="tx-grid"></div>
        </div>

        <el-container class="tx-body">
            <el-header class="tx-header" height="72px">
                <div class="tx-header-inner">
                    <div class="tx-brand">
                        <div class="tx-logo-box">
                            <el-image class="tx-logo" src="/img/logo.svg"></el-image>
                        </div>
                        <div class="tx-brand-text">
                            <span class="tx-brand-title">纯净未知</span>
                            <span class="tx-brand-sub">文档转换引擎</span>
                        </div>
                    </div>

                    <el-menu class="tx-menu" mode="horizontal" router text-color="#8fa3c8"
                        active-text-color="#22d3ee" :default-active="$route.path">
                        <el-menu-item index="/">文件转换</el-menu-item>
                        <el-menu-item index="/pdf-tools">PDF 工具</el-menu-item>
                        <el-menu-item index="/image-tools">图片工具</el-menu-item>
                        <el-menu-item index="/codec-tools">编码工具</el-menu-item>
                        <el-menu-item index="/ocr">OCR 识别</el-menu-item>
                        <el-menu-item index="/tasks">任务中心</el-menu-item>
                    </el-menu>

                    <!-- 网页版已移除注册 / 登录入口：全站免登录使用 -->

                    <div class="tx-status">
                        <span class="tx-dot"></span>SYSTEM ONLINE
                    </div>
                </div>
            </el-header>

            <el-main class="tx-main">
                <slot></slot>
                <!-- SEO 说明区块：与构建期预渲染共用同一份数据（src/data/tool-seo.js） -->
                <ToolSeoSection :path="$route.path" />
            </el-main>

            <el-footer class="tx-footer" height="60px">
                <div class="tx-footer-inner">
                    <ul class="tx-footer-nav">
                        <li><router-link to="/">文件转换</router-link></li>
                        <li><router-link to="/pdf-tools">PDF 工具</router-link></li>
                        <li><router-link to="/image-tools">图片工具</router-link></li>
                        <li><router-link to="/codec-tools">编码工具</router-link></li>
                        <li><router-link to="/ocr">OCR 识别</router-link></li>
                        <li><router-link to="/tasks">任务中心</router-link></li>
                    </ul>
                    <span class="tx-privacy-foot"><i class="el-icon-lock"></i> 隐私保护：上传文件与转换结果将在 7 天后自动删除</span>
                    <p class="tx-footer-copy">联系方式：18620429891</p>
                </div>
            </el-footer>
        </el-container>
    </el-container>
</template>

<style>
/* ================= 全局基底 ================= */
html,
body {
    margin: 0;
    padding: 0;
    background: #070b14;
}

.tx-page {
    height: 100vh;
    position: relative;
    overflow: hidden;
    background: #070b14;
    font-family: "PingFang SC", "Microsoft YaHei", Avenir, Helvetica, Arial, sans-serif;
}

/* ================= 背景装饰 ================= */
.tx-bg {
    position: absolute;
    inset: 0;
    z-index: 0;
    pointer-events: none;
    overflow: hidden;
}

.tx-orb {
    position: absolute;
    border-radius: 50%;
    filter: blur(110px);
    opacity: .35;
}

.tx-orb-cyan {
    width: 560px;
    height: 560px;
    top: -180px;
    left: -120px;
    background: radial-gradient(circle, #0891b2 0%, transparent 70%);
    animation: txFloat 14s ease-in-out infinite alternate;
}

.tx-orb-purple {
    width: 520px;
    height: 520px;
    bottom: -200px;
    right: -100px;
    background: radial-gradient(circle, #6d28d9 0%, transparent 70%);
    animation: txFloat 18s ease-in-out infinite alternate-reverse;
}

.tx-orb-blue {
    width: 380px;
    height: 380px;
    top: 40%;
    left: 55%;
    background: radial-gradient(circle, #1d4ed8 0%, transparent 70%);
    opacity: .22;
    animation: txFloat 22s ease-in-out infinite alternate;
}

@keyframes txFloat {
    from {
        transform: translate(0, 0) scale(1);
    }

    to {
        transform: translate(60px, 40px) scale(1.15);
    }
}

.tx-grid {
    position: absolute;
    inset: 0;
    background-image:
        linear-gradient(rgba(56, 189, 248, .05) 1px, transparent 1px),
        linear-gradient(90deg, rgba(56, 189, 248, .05) 1px, transparent 1px);
    background-size: 44px 44px;
    mask-image: radial-gradient(ellipse at 50% 40%, #000 30%, transparent 75%);
    -webkit-mask-image: radial-gradient(ellipse at 50% 40%, #000 30%, transparent 75%);
}

/* ================= 主体容器 ================= */
.tx-body {
    position: relative;
    z-index: 1;
    height: 100%;
}

/* ================= 顶栏 ================= */
.tx-header {
    padding: 0 !important;
    background: rgba(10, 16, 30, .72);
    backdrop-filter: blur(14px);
    -webkit-backdrop-filter: blur(14px);
    border-bottom: 1px solid rgba(56, 189, 248, .18);
}

.tx-header-inner {
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 36px;
    gap: 28px;
}

.tx-brand {
    display: flex;
    align-items: center;
    gap: 12px;
}

.tx-logo-box {
    /* 与官网一致改用完整品牌 logo（宽高比 186:138，比原纯标识更宽），故加宽槽位 */
    width: 58px;
    height: 44px;
    border-radius: 10px;
    /* 品牌图形是透明底的亮绿 C 环，需要深色底承载；
       底色取中性半透明白，光晕沿用工具站的青色主题色 */
    background: rgba(255, 255, 255, .07);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 18px rgba(34, 211, 238, .30);
    overflow: hidden;
}

.tx-logo {
    /* 官网同款 logo：宽高比 186:138，按高度撑满、宽度自适应，不拉伸变形 */
    height: 32px;
    width: auto;
}

.tx-brand-text {
    display: flex;
    flex-direction: column;
    line-height: 1.25;
}

.tx-brand-title {
    font-size: 17px;
    font-weight: 700;
    letter-spacing: 2px;
    background: linear-gradient(90deg, #e2f5ff, #22d3ee);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
}

.tx-brand-sub {
    font-size: 11px;
    letter-spacing: 4px;
    color: #5b7295;
}

/* 菜单 */
.tx-menu {
    flex: 1;
    background: transparent !important;
    border-bottom: none !important;
    margin-left: 24px;
}

.tx-menu .el-menu-item {
    height: 72px !important;
    line-height: 72px !important;
    font-size: 15px !important;
    border-bottom: none !important;
    letter-spacing: 1px;
}

.tx-menu .el-menu-item:hover {
    background: rgba(56, 189, 248, .08) !important;
    color: #e2f5ff !important;
}

.tx-menu .el-menu-item.is-active {
    border-bottom: none !important;
    position: relative;
}

.tx-menu .el-menu-item.is-active::after {
    content: "";
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 12px;
    width: 26px;
    height: 2px;
    border-radius: 2px;
    background: linear-gradient(90deg, #22d3ee, #6366f1);
    box-shadow: 0 0 8px rgba(34, 211, 238, .8);
}

/* 账户区 */
.tx-account {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 14px;
    border: 1px solid rgba(56, 189, 248, .22);
    border-radius: 999px;
    background: rgba(7, 12, 24, .5);
    font-size: 13px;
    color: #c7d7ee;
}

.tx-account-name {
    color: #e2f5ff;
    font-weight: 600;
}

.tx-account-quota {
    color: #22d3ee;
    font-size: 12px;
}

.tx-account-login {
    color: #22d3ee !important;
    border: 1px solid rgba(34, 211, 238, .4) !important;
    border-radius: 999px !important;
    padding: 6px 16px !important;
}

/* 状态灯 */
.tx-status {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 11px;
    letter-spacing: 2px;
    color: #34d399;
    padding: 6px 14px;
    border: 1px solid rgba(52, 211, 153, .3);
    border-radius: 999px;
    background: rgba(52, 211, 153, .06);
}

.tx-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #34d399;
    box-shadow: 0 0 8px #34d399;
    animation: txPulse 1.6s ease-in-out infinite;
}

@keyframes txPulse {

    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: .3;
    }
}

/* ================= 主区域 ================= */
.tx-main {
    padding: 0 !important;
    height: calc(100vh - 132px);
    overflow-y: auto;
}

.tx-main::-webkit-scrollbar {
    width: 8px;
}

.tx-main::-webkit-scrollbar-thumb {
    background: rgba(56, 189, 248, .25);
    border-radius: 4px;
}

/* ================= 底栏 ================= */
.tx-footer {
    padding: 0 !important;
    background: rgba(10, 16, 30, .72);
    backdrop-filter: blur(14px);
    border-top: 1px solid rgba(56, 189, 248, .14);
}

.tx-footer-inner {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 36px;
}

.tx-footer-nav {
    list-style: none;
    display: flex;
    gap: 26px;
    margin: 0;
    padding: 0;
}

.tx-footer-nav a {
    color: #5b7295;
    font-size: 13px;
    text-decoration: none;
    transition: color .2s;
}

.tx-footer-nav a:hover {
    color: #22d3ee;
}

.tx-footer-copy {
    margin: 0;
    color: #5b7295;
    font-size: 12px;
    letter-spacing: 1px;
}

/* ================= 响应式（移动端） ================= */
@media (max-width: 768px) {
    .tx-header-inner {
        padding: 0 14px;
        gap: 12px;
        overflow-x: auto;
    }

    .tx-brand-text {
        display: none;
    }

    .tx-menu {
        margin-left: 8px;
    }

    .tx-menu .el-menu-item {
        padding: 0 10px;
        font-size: 13px !important;
    }

    .tx-status {
        display: none;
    }

    .tx-footer-inner {
        padding: 0 14px;
        flex-direction: column;
        gap: 6px;
        justify-content: center;
    }

    .tx-footer-nav {
        flex-wrap: wrap;
        justify-content: center;
        gap: 14px;
    }
}

.tx-account-link { text-decoration: none; }
.tx-account-link:hover { color: #22d3ee; }
.tx-privacy-foot {
    color: #5b7295;
    font-size: 12px;
    letter-spacing: .5px;
    margin-left: 18px;
}
.tx-privacy-foot i { color: #34d399; margin-right: 4px; }

</style>

<script>
import ToolSeoSection from './ToolSeoSection.vue';

export default {
    components: { ToolSeoSection },
    data() {
        return {

        }
    }
};
</script>
